import axios from 'utils/axios';
import { put } from 'redux-saga/effects';
import * as RequestLoginCredentials from 'actions/RequestLoginCredentials';

export function* onCreateRequest({ payload, cb }) {
  try {

    const res = yield axios.post(`/api/auth/emailLogin`, `"${payload}"`);

    yield put(RequestLoginCredentials.onCreateSuccess(res));

    cb && cb(null);
  } catch (e) {
    cb && cb(e);
  }
}
